import type { RawDraftEntity } from 'draft-js';
import { TiptapContentMark, TiptapMarkType } from '../../../tiptapTypes';
import { mentionSuggestionToAttrs } from '../../../extensions/mention/MentionSuggestion';

type EntityToMarkConverter = (entity: RawDraftEntity, key: string) => TiptapContentMark | null;

const entityToMarkConverters: Record<string, EntityToMarkConverter> = {
    link: (entity) => ({
        type: 'link',
        attrs: {
            href: entity.data?.url,
            target: '_blank',
            rel: 'noopener noreferrer nofollow',
            class: null,
        },
    }),
    mention: (entity, key) => ({
        type: TiptapMarkType.textMention,
        attrs: mentionSuggestionToAttrs(entity.data.mention, key),
    }),
    // There are no other known Draft.js entity types that Milanote handles,
    //  and our Tiptap schema needs to support them, so we return null here
    //  to strip them out of the content.
    default: () => null,
};

export const convertEntityToMark = (entity: RawDraftEntity, key: string): TiptapContentMark | null => {
    const type = entity.type?.toLowerCase();
    const entityConverter = entityToMarkConverters[type] || entityToMarkConverters.default;
    return entityConverter(entity, key);
};
